import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { GetBusinessCustomerResponseDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';

type Req = {
  customerId: number | undefined;
  disable?: boolean;
};

type Return = {
  customerDetails: GetBusinessCustomerResponseDto | undefined;
  isErrorGettingCustomerDetails: boolean;
  isGettingCustomerDetails: boolean;
};

export const useGetCustomerDetailsBusiness = (req: Req): Return => {
  const { customersApi } = useApiClient();

  const { data, isError, isPending } = useQuery<
    GetBusinessCustomerResponseDto | undefined,
    AxiosError
  >({
    enabled: !req.disable && Boolean(req.customerId),
    queryFn: async () => {
      if (!req.customerId) {
        return;
      }
      const { data } = await customersApi.getBusinessCustomer(req.customerId);
      return data;
    },
    queryKey: [QueryKeyEnum.CUSTOMERS.DETAILS, req.customerId],
  });

  return {
    customerDetails: data,
    isErrorGettingCustomerDetails: isError,
    isGettingCustomerDetails: isPending,
  };
};
